import { API } from '../../api/API';
import {
  USER_BILLS_FOR_ACCOUNT_URL,
  USER_ACCOUNT_URL, BUSINESS_ACCOUNT_TYPES_URL,USER_BILLS
} from '../../config/config';
import _ from "lodash";


export const getAccountTypeNameFromId = (accountTypeId, accountTypes) => {
  let accountTypeName = accountTypes.filter(accountType => accountType.id === accountTypeId)
    .map(filteredAccountType => (filteredAccountType.accountTypeDisplayName));
  return accountTypeName;
}

export const getAccountTypeFromId = (accountTypeId, accountTypes) => {
  let accountType = accountTypes.filter(accountType => accountType.id === accountTypeId);
  if (_.isEmpty[accountType]){
    return null;
  }
  return accountType[0];
}

export const listAccountTypes = async () => {
  let response = await API.get(BUSINESS_ACCOUNT_TYPES_URL)
  return response.data;
}

export const getAccountDetailsById = async (accountId) => {
  let response = await API.get(USER_ACCOUNT_URL + '/' + accountId + "/accountdetails");
  return response.data;
}

export const listUserBillsForAccount = async (accountId, page, size) => {
  let userBillsForAccountUrl = USER_BILLS_FOR_ACCOUNT_URL;
  if (accountId) {
    userBillsForAccountUrl = USER_BILLS_FOR_ACCOUNT_URL + "/" + accountId;
  }
  let response = await API.get(userBillsForAccountUrl,{
    params: {
      size: size,
      page: page
    }
})
  return response.data;
}

export const getUserBillByBillId = async (billId) => {
  let billUrl = USER_BILLS+"/"+billId;
  let response = await API.get(billUrl);
  return response.data;
}



